<template>
  <v-container fluid>
    <v-layout column >
      <v-flex>
        <filters-bar
          :filters="filters"
          :filtersButton="false"
          :has-date-type="false"
          title="Segmentación inteligente"
          title-class="headline"
          date-box-size="md3"
          @search="search">
          <template slot="content">
            <v-flex shrink>
              <v-select
                solo
                label="Tramo"
                color="grey"
                :items="tranches"
                v-model="filters.segment_tranche"
                @input="search">
              </v-select>
            </v-flex>
            <v-flex shrink>
              <v-select
                solo
                label="Ordenamiento"
                color="grey"
                :items="orders"
                v-model="order">
              </v-select>
            </v-flex>
            <v-flex shrink>
              <v-select
                solo
                label="Tipo"
                color="grey"
                :items="types"
                v-model="filters.cycle"
                @input="search">
              </v-select>
            </v-flex>
          </template>
        </filters-bar>
      </v-flex>
      <v-flex >
        <detail :total="sumTotal" 
          :is-searching="isSearching" 
          :data="transformedData" 
          @update-segment="updateSegment" 
          @segment="segmentation"
          @variables="showVariable = true">
        </detail>
      </v-flex>
      <v-flex>
        <distribution :is-searching="isSearching" @segment="segmentation" :data="transformedData" class="mt-4">
        </distribution>
      </v-flex>
    </v-layout>
    <info-modal v-if="showModal" :show="showModal" @change="showModal = $event" :group="segment"
      @download="generateReport()">
    </info-modal>
    <variables v-if="showVariable" 
      @show-error="showError = true"
      @change="showVariable = $event" 
      :filters="filters"
      :show="showVariable">
    </variables>
    <alert-modal :show="showError">
      <template slot="content">
        <v-layout row wrap>
          <v-flex xs12 text-xs-center>
            <span class="mt-2">
              El proceso que esta intentando ejecutar ya esta en proceso
            </span>
          </v-flex>
        </v-layout>
      </template>
    </alert-modal>
  </v-container>
</template>
<script>
import moment from 'moment';
import _ from 'lodash';
import FiltersBar from '@/components/global/FiltersBar';
import AlertModal from '@/components/global/AlertModal';
import Detail from './Detail';
import InfoModal from './InfoModal';
import Variables from './VariablesModal';
import Distribution from './distribution/Index';

export default {
  components: {
    Detail,
    InfoModal,
    Variables,
    FiltersBar,
    AlertModal,
    Distribution,
  },
  mounted() {
    this.search();
  },
  data() {
    return {
      data: [],
      order: false,
      showError: false,
      showModal: false,
      isSearching: true,
      showVariable: false,
      segment: {},
      orders: [
        {
          text: 'Mas riesgo',
          value: false,
        },
        {
          text: 'Menos riesgo',
          value: true,
        },
      ],
      tranches: [
        {
          text: 'Menor a 30',
          value: 1,
        },
        {
          text: 'Entre 31 y 60',
          value: 2,
        },
        {
          text: 'Mayor a 61',
          value: 3,
        },
      ],
      cancelToken: this.axios.CancelToken.source(),
      filters: {
        cycle: 1,
        segment_tranche: 1,
        dateType: 'month',
        date: moment().format('YYYY-MM'),
      },
    };
  },
  computed: {
    sumTotal() {
      const total = _.sumBy(this.data, this.totalField);
      return parseInt(total, 10);
    },
    totalField() {
      return `customers_quantity_${this.filters.cycle ? 'total' : 'due'}`;
    },
    types() {
      return [
        {
          text: 'Actual',
          value: 0,
          disabled: this.filters.date !== moment().format('YYYY-MM'),
        },
        {
          text: 'Mensual',
          value: 1,
        },
        {
          text: 'Trimestral',
          value: 3,
        },
        {
          text: 'Semestral',
          value: 6,
        },
        {
          text: 'Anual',
          value: 12,
        },
      ];
    },
    transformedData() {
      return _.chain(this.data)
        .map(item => ({
          name: item.id,
          // eslint-disable-next-line
          percentage: parseFloat(this.order ? (item.scoring || 0).toFixed(2) : (Math.abs((100 - item.scoring) || 0)).toFixed(2)),
          quantity: item[this.totalField],
          percentageOfGlobal: ((item[this.totalField] * 100) / this.sumTotal).toFixed(2),
          dueBalance: (item[`due_balance_${this.filters.cycle ? 'total' : 'due'}`] || 0).toFixed(2),
          sms: ((item[`sms_p_${this.filters.cycle ? 'total' : 'due'}`] || 0) * 100).toFixed(2),
          email: ((item[`email_p_${this.filters.cycle ? 'total' : 'due'}`] || 0) * 100).toFixed(2),
          phone: ((item[`phone_p_${this.filters.cycle ? 'total' : 'due'}`] || 0) * 100).toFixed(2),
          segment_detail: _.reduce(item.segment_detail, (result, value) => {
            // eslint-disable-next-line
            const filters = _.pickBy(value, (x, key) => {
              return (!['id', 'segment_id'].includes(key) && x);
            });
            _.each(filters, (x, key) => {
              /* eslint-disable */
              (result[key] || (result[key] = [])).push(x);
              result[key] = _.uniq(result[key]);
              /* eslint-enable */
            });
            return result;
          }, {}),
        }))
        .orderBy('percentage', 'desc')
        .each((item, i) => {
          // eslint-disable-next-line
          item.letter = String.fromCharCode(97 + (i < 26 ? i : ( i - (26 * Math.floor(i / 26))))).toUpperCase();
          if (i > 25) {
            // eslint-disable-next-line
            item.letter += ` - ${Math.floor(i / 26)}`;
          }
        })
        .value();
    },
  },
  methods: {
    search() {
      this.isSearching = true;
      this.cancelToken.cancel('');
      this.cancelToken = this.axios.CancelToken.source();
      this.axios.get('segments/report', {
        cancelToken: this.cancelToken.token,
        params: {
          ...this.filters,
          cycle: this.filters.cycle > 0 ? this.filters.cycle : 1,
        },
      }).then(({ data }) => {
        this.data = data;
      }).catch(() => {
      }).finally(() => {
        this.isSearching = false;
      });
    },
    segmentation(segment) {
      this.segment = segment;
      this.showModal = true;
    },
    updateSegment() {
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'update/segments',
        params: {
          functionName: 'assign_segments',
          filters: {
            ...this.filters,
            cycle: this.filters.cycle > 0 ? this.filters.cycle : 1,
          },
        },
      }).catch(({ response }) => {
        if (response.status === 418) {
          this.showError = true;
        }
      });
    },
    generateReport() {
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'reports',
        params: {
          filters: {
            ...this.filters,
            segment: this.segment.name,
            cycle: this.filters.cycle > 0 ? this.filters.cycle : 1,
          },
          functionName: 'segments',
        },
      });
    },
  },
  watch: {
    'filters.date': {
      handler(value) {
        if (!this.filters.cycle && value !== moment().format('YYYY-MM')) {
          this.filters.cycle = 1;
        }
      },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/reports/segmentation/Index.vue